import React from "react";

import { cn } from "@/lib/helpers/cn";
import type { Appointment, AppointmentSlot } from "@/lib/types/schedule";

import { adjustAppointmentSlots, getDateFromAppointment, getTodaysDate } from "./helpers";
import { MakeTimeSlotButton } from "./MakeTimeSlotButton";

type DayProps = {
  appointment: Appointment;
  maxDaySize: number;
  selectedAppointment: Nullable<AppointmentSlot>;
  setSelectedAppointment: (appointment: Nullable<AppointmentSlot>) => void;
};

export const Day = ({
  appointment,
  maxDaySize,
  selectedAppointment,
  setSelectedAppointment,
}: DayProps) => {
  const adjustedAppointmentSlots = adjustAppointmentSlots(appointment.slots, maxDaySize);
  const appointmentDate = getDateFromAppointment(appointment);
  const today = getTodaysDate();
  const isToday = appointmentDate.isSame(today, "day");
  const formattedDate = appointmentDate.format("MMM DD");

  return (
    <div
      className={cn(
        "tw:mb-3 tw:flex tw:min-h-full tw:flex-col tw:text-center",
        isToday && "tw:rounded-sm tw:bg-layer-floor-0",
      )}
      id="calendar-col"
      key={`${appointment.month_of_year}-${appointment.day}-col`}
      /** This aria attribute is required for e2e tests */
      aria-current={isToday ? "date" : undefined}
    >
      <div
        className="body-sm tw:leading-5 tw:text-text-tertiary"
        /** This role is required for e2e tests */
        role="columnheader"
      >
        {appointment.day_of_week}
      </div>
      <time
        dateTime={appointmentDate.toISOString()}
        className="body-md tw:leading-6 tw:font-bold tw:text-text-secondary"
      >
        {formattedDate}
      </time>

      <div className="tw:mt-8 tw:flex tw:flex-col tw:gap-2 tw:px-1">
        {adjustedAppointmentSlots.map((slot, index) => (
          <MakeTimeSlotButton
            key={`slot-${index}`}
            selectedAppointment={selectedAppointment}
            setSelectedAppointment={setSelectedAppointment}
            slot={slot}
          />
        ))}
      </div>
    </div>
  );
};
